import './TermCondition.css';

export default function TermCondition() {
    
    return (
        <>
            <section id="teacher-policy-section">
                <div className="teacher-policy-container">
                    <div className="policy-header">
                        <p className="policy-intro">
                            These policies apply to all teachers, trainers, visiting faculty, and guest artists working with HSM, 
                            regardless of subject, program, or location. By accepting an offer/assignment with HSM, you agree to 
                            abide by the following:
                        </p>
                    </div>

                    <div className="policy-content">
                        {/* Section 1: Appointment & Engagement */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">1. Appointment & Engagement</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers are engaged as independent contractors unless otherwise specified.</li>
                                    <li>All teaching assignments, schedules, and programs are allocated by HSM.</li>
                                    <li>A written agreement or email confirmation from HSM is mandatory before starting any class.</li>
                                    <li>Teachers must disclose any other teaching engagements to ensure no conflict of interest.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 2: Confidentiality & Non-Solicitation */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">2. Confidentiality & Non-Solicitation</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>All student and academy information is confidential.</li>
                                    <li>Teachers must not solicit or teach HSM students privately.</li>
                                    <li>Teachers must not share their personal contact details (phone, email, social media) directly with students or parents; all communication should go through official HSM channels.</li>
                                    <li>Breach of this clause may result in immediate termination without release of pending salary and legal action.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 3: Professional Conduct */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">3. Professional Conduct</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must maintain respectful, courteous, and professional behaviour at all times with students, parents, and staff.</li>
                                    <li>Use of inappropriate language, discriminatory remarks, or harassment is strictly prohibited.</li>
                                    <li>Punctuality is mandatory - teachers should join online/offline sessions at least 5 minutes early.</li>
                                    <li>Teachers are role models; appearance and attire must be neat and appropriate for class.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 4: Class Planning & Delivery */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">4. Class Planning & Delivery</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers are responsible for preparing lesson plans aligned with HSM's curriculum and learning outcomes.</li>
                                    <li>Teachers should update progress in the student dashboard after each class.</li>
                                    <li>Teachers must follow HSM's prescribed teaching methodologies for consistency across programs.</li>
                                    <li>Teachers must ensure proper equipment (camera, mic, stable internet).</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 5: Attendance & Scheduling */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">5. Attendance & Scheduling</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must inform HSM 24 hours, or at least 6 hours in advance if they are unable to take a class.</li>
                                    <li>In emergencies, teachers must notify the academy immediately to arrange a substitute or reschedule.</li>
                                    <li><strong>Rescheduling Limit:</strong> A teacher may request to reschedule or cancel a maximum of 4 classes per month without penalty. Any additional cancellations beyond this limit may result in reduced payment, reassignment of students, or disciplinary action at HSM's discretion.</li>
                                    <li>Teachers are expected to maintain a consistent teaching schedule to ensure student progress.</li>
                                    <li>Last-minute cancellations (less than 6 hours before class) are strongly discouraged and counted within the monthly limit.</li>
                                    <li>Teachers may be shifted between students or batches if HSM deems it necessary.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 6: Payment & Invoicing */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">6. Payment & Invoicing</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers will be paid as per the agreed rate (per session or monthly).</li>
                                    <li>Payment cycles and methods will be communicated in writing.</li>
                                    <li>Teachers must submit attendance sheets or invoices on time to process payment.</li>
                                    <li>HSM reserves the right to withhold payment if policies are violated or classes not delivered.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 7: Use of Academy Resources */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">7. Use of Academy Resources</h3>
                            </div>
                            <div className="policy-section-content">
                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Authorized Use Only:</h4>
                                    <p>All teaching materials, lesson plans, student dashboards, logins, software licenses, and equipment (such as instruments, microphones, studio space, or online platforms) provided by HSM are strictly for official teaching purposes. They must not be used for personal gain, outside classes, or third-party teaching activities.</p>
                                </div>
                                
                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Digital Access:</h4>
                                    <p>Teachers will be given official credentials to access the HSM dashboard, online class platforms, and internal communication tools. Sharing these credentials with outsiders or using them for non-HSM activities is strictly prohibited.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Intellectual Property:</h4>
                                    <p>Any curriculum, study material, exercises, videos, or recordings developed under HSM (whether by the academy or the teacher during their tenure) remain the property of HSM. Teachers may not copy, distribute, or use these materials outside the academy without written permission.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Equipment & Instruments (Offline):</h4>
                                    <p>Any instruments, technical equipment, or software provided for teaching must be maintained properly and returned in good condition after use. Teachers are responsible for reporting any damage, malfunction, or loss immediately.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Recording Classes:</h4>
                                    <p>Teachers are not allowed to record classes on personal devices or share student data/content externally. Any recordings or screenshots for academic purposes must be approved and stored only in HSM's secure systems.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Confidentiality:</h4>
                                    <p>Teachers must maintain strict confidentiality of all student data, contact information, progress reports, or academy-related documents accessed through the dashboard or provided by the academy.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Prohibition on Solicitation:</h4>
                                    <p>Teachers may not solicit HSM students for private lessons, personal projects, or competing academies using HSM's resources or contacts. Any such action will be treated as a breach of contract.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Monitoring & Compliance:</h4>
                                    <p>HSM reserves the right to monitor the use of its digital platforms, instruments, and resources to ensure compliance with policies. Any misuse may lead to disciplinary action, financial liability, or termination.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 8: Student Interaction Rules */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">8. Student Interaction Rules</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must not request or accept gifts, cash, or personal favours from students/parents.</li>
                                    <li>Teachers must not engage in private tuition, coaching, or business with current HSM students unless authorised.</li>
                                    <li>Teachers must immediately report any student misconduct or issues to HSM management.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 9: Recordings & Intellectual Property */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">9. Recordings & Intellectual Property</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Online classes may be recorded by HSM for quality monitoring and training, and promotional purposes.</li>
                                    <li>Teachers must not record classes or use recordings for personal use unless explicitly permitted.</li>
                                    <li>Any content created during HSM classes (arrangements, exercises, performances) belongs to HSM unless otherwise agreed.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 10: Performance Opportunities & Events */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">10. Performance Opportunities & Events</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers may be invited to perform at HSM events or showcases.</li>
                                    <li>Any such engagement is optional and may be separately compensated if not part of teaching duties.</li>
                                    <li>Teachers must represent HSM positively during all public events.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 11: Health & Safety */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">11. Health & Safety</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must ensure safe vocal/instrument techniques to avoid injury to students.</li>
                                    <li>Any health issue that could impact teaching must be disclosed to HSM.</li>
                                    <li>Teachers must maintain a safe environment in offline classes, following all academy safety guidelines.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 12: Communication Protocol */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">12. Communication Protocol</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>All scheduling, complaints, or queries must go through HSM's official email or phone lines.</li>
                                    <li>Teachers must not discuss fees, internal policies, or confidential matters directly with students or parents.</li>
                                    <li>Social media interaction with students should be limited to official HSM pages or groups.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 13: Curriculum Development & Reporting */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">13. Curriculum Development & Reporting</h3>
                            </div>
                            <div className="policy-section-content">
                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Adherence to Academy Curriculum:</h4>
                                    <p>All teachers are required to follow the standard HSM curriculum and teaching framework provided for each subject. This ensures consistency and quality across all classes.</p>
                                </div>
                                
                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Customization for Students:</h4>
                                    <p>Teachers may adapt lesson plans or exercises to suit a student's level, learning speed, or goals, but the core modules and objectives outlined by HSM must always be covered. Any major changes to the curriculum must be pre-approved by the Academic Head.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Lesson Planning:</h4>
                                    <p>Teachers are expected to maintain a weekly or monthly lesson plan for each student or batch. Plans should include topics covered, upcoming topics, practice assignments, and exam preparation (if applicable).</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Progress Tracking:</h4>
                                    <p>After every class, teachers must update the student dashboard with attendance, class notes, practice/homework assignments, daily class updates and feedback. This ensures students and parents can track progress in real time.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Monthly Reports:</h4>
                                    <p>Teachers must submit monthly progress reports for each student, summarising:</p>
                                    <ul className="policy-sublist">
                                        <li>Topics covered</li>
                                        <li>Skills developed</li>
                                        <li>Strengths and areas of improvement</li>
                                        <li>Recommendations for further learning or exam preparation</li>
                                        <li>Attendance record etc</li>
                                    </ul>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Evaluation & Feedback:</h4>
                                    <p>Teachers must conduct periodic assessments (mid-course and end-of-course evaluations) to measure student progress. Assessment results must be uploaded to the dashboard within 48 hours.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Resource Development:</h4>
                                    <p>If a teacher develops any new study material, exercises, or resources for students, these should be shared with the academy for approval before distribution if not shared on students dashboard, or through HSM provided platforms. All created materials remain the intellectual property of HSM.</p>
                                    <p>Any form of material uploaded or provided to the student must not have any form of teacher identification information containing in it.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Communication with Academic Head:</h4>
                                    <p>Teachers must promptly inform the Academic Head of any student's unusual progress, difficulties, behavioural issues, or special achievements.</p>
                                </div>

                                <div className="policy-subsection">
                                    <h4 className="policy-subsection-title">Standardization:</h4>
                                    <p>Teachers may be asked to participate in curriculum improvement meetings or training workshops organised by HSM to ensure all staff follow the most updated and effective teaching practices.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 14: Probation & Evaluation */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">14. Probation & Evaluation</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>New teachers may be on probation for the first 3 months.</li>
                                    <li>HSM reserves the right to monitor classes and provide feedback.</li>
                                    <li>Unsatisfactory performance during probation may lead to termination.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 15: Replacement & Termination */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">15. Replacement & Termination</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>HSM may reassign students or classes to another teacher if it believes it is in the student's best interest.</li>
                                    <li>Any violation of policies (especially confidentiality or non-solicitation) may result in immediate removal without notice.</li>
                                    <li>Either party may terminate the engagement by providing written notice as specified in the contract.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 16: Conflict of Interest */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">16. Conflict of Interest</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must disclose any competing business or employment that overlaps with HSM's services.</li>
                                    <li>Teachers must not promote their own courses, products, or brands to HSM students.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 17: Technology & Data Security */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">17. Technology & Data Security (Online Classes)</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers must use only authorised software and links provided by HSM for classes.</li>
                                    <li>Teachers must not share login credentials or student data with any third party.</li>
                                    <li>Teachers must ensure their devices are secure from malware to protect student data.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 18: Policy Updates */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">18. Policy Updates</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>HSM reserves the right to update these policies to maintain quality and compliance.</li>
                                    <li>Continued teaching under HSM after updates constitutes acceptance of the new policies.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 19: Long-Term Leave */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">19. Long-Term Leave</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Teachers who plan to take extended leave (more than 3 consecutive teaching days) must submit a leave request in writing at least 2 weeks in advance for approval.</li>
                                    <li>HSM will arrange substitute teachers or adjust schedules to ensure uninterrupted student learning.</li>
                                    <li>Long-term leave without prior approval may result in loss of classes, reduced payment, or termination of the engagement.</li>
                                    <li>Any extended absence must be discussed and approved by HSM's management before being implemented.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 20: Legal & Jurisdiction */}
                        <div className="policy-section">
                            <div className="policy-section-header">
                                <h3 className="policy-section-title">20. Legal & Jurisdiction</h3>
                            </div>
                            <div className="policy-section-content">
                                <ul className="policy-list">
                                    <li>Any dispute arising out of the teacher's engagement with HSM will be subject to the jurisdiction of courts.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Acknowledgement Section */}
                        <div className="policy-acknowledgement">
                            <h3 className="acknowledgement-title">Acknowledgement</h3>
                            <p className="acknowledgement-text">
                                All teachers must sign an acknowledgment stating they have read and agreed to abide by these policies 
                                before starting classes.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}